import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, HostListener } from '@angular/core';
import { uniqueId, toBoolean } from '../util/util';
var NglDatepicker = (function () {
    function NglDatepicker() {
        this.monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        this.dayNamesShort = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        this.dayNamesLong = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursda', 'Friday', 'Saturday'];
        this.dateChange = new EventEmitter();
        this.showToday = true;
        this.firstDayOfWeek = 0;
        this.uid = uniqueId('datepicker');
        // Split array into smaller arrays
        this.split = function (arr, size) {
            if (size === void 0) { size = 7; }
            var arrays = [];
            while (arr.length > 0) {
                arrays.push(arr.splice(0, size));
            }
            return arrays;
        };
    }
    Object.defineProperty(NglDatepicker.prototype, "_date", {
        set: function (date) {
            this.date = this.parseDate(date);
            if (this.date) {
                this.current = Object.assign({}, this.date);
            }
            this.render();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NglDatepicker.prototype, "_showToday", {
        set: function (showToday) {
            this.showToday = toBoolean(showToday);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NglDatepicker.prototype, "_firstDayOfWeek", {
        set: function (firstDayOfWeek) {
            this.firstDayOfWeek = +firstDayOfWeek;
            this.render();
        },
        enumerable: true,
        configurable: true
    });
    NglDatepicker.prototype.moveYear = function (year) {
        this.current.year = +year;
        this.render();
    };
    NglDatepicker.prototype.keyboardHandler = function ($event, code, param) {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        if (code === 'Enter') {
            this.select();
            return;
        }
        // Change current date
        var _a = this.current, year = _a.year, month = _a.month, day = _a.day;
        var date = new Date(year, month, day, 12);
        if (code === 'Move') {
            date.setDate(day + (+param));
            this.current = { year: date.getFullYear(), month: date.getMonth(), day: date.getDate() };
        }
        else if (code === 'MoveMonth') {
            date.setMonth(month + (+param), 1);
            this.current = { year: date.getFullYear(), month: date.getMonth(), day: day };
        }
        else if (code === 'MoveTo') {
            this.current.day = +param;
        }
        this.render();
    };
    NglDatepicker.prototype.isSelected = function (date) {
        return this.isEqualDate(date, this.date);
    };
    NglDatepicker.prototype.isActive = function (date) {
        return this.isEqualDate(date, this.current);
    };
    NglDatepicker.prototype.select = function (date) {
        if (date === void 0) { date = this.current; }
        if (date.disabled)
            return;
        var year = date.year, month = date.month, day = date.day;
        this.dateChange.emit(new Date(year, month, day));
    };
    NglDatepicker.prototype.indexTrackBy = function (index) {
        return index;
    };
    NglDatepicker.prototype.selectToday = function () {
        this.dateChange.emit(new Date());
    };
    NglDatepicker.prototype.parseDate = function (date) {
        if (!date)
            return null;
        return { year: date.getFullYear(), month: date.getMonth(), day: date.getDate() };
    };
    NglDatepicker.prototype.isEqualDate = function (d1, d2) {
        return d1 && d2 && d1.day === d2.day && d1.month === d2.month && d1.year === d2.year;
    };
    NglDatepicker.prototype.render = function () {
        if (!this.current) {
            this.current = this.today;
        }
        var _a = this.current, year = _a.year, month = _a.month, day = _a.day;
        this.monthLabel = this.monthNames[month];
        var days = this.daysInMonth(year, month);
        // Keep current day inside limits of this month
        this.current.day = Math.min(day, days.length);
        Array.prototype.unshift.apply(days, this.daysInPreviousMonth(year, month));
        var nextMonth = this.daysInNextMonth(year, month + 1, days.length);
        if (nextMonth) {
            Array.prototype.push.apply(days, nextMonth);
        }
        this.weeks = this.split(days);
    };
    NglDatepicker.prototype.daysInMonth = function (year, month) {
        var last = new Date(year, month + 1, 0).getDate();
        return this.getDayObjects(year, month, 1, last);
    };
    NglDatepicker.prototype.daysInPreviousMonth = function (year, month) {
        var firstIndex = (new Date(year, month, 1)).getDay();
        var last = new Date(year, month, 0).getDate();
        var numDays = (7 + firstIndex - this.firstDayOfWeek) % 7;
        return this.getDayObjects(year, month - 1, last - numDays + 1, last, true);
    };
    NglDatepicker.prototype.daysInNextMonth = function (year, month, numOfDays) {
        if (numOfDays % 7 === 0)
            return;
        return this.getDayObjects(year, month, 1, 7 - (numOfDays % 7), true);
    };
    NglDatepicker.prototype.getDayObjects = function (year, month, from, to, disabled) {
        if (disabled === void 0) { disabled = false; }
        var days = [];
        for (var day = from; day <= to; day++) {
            days.push({ year: year, month: month, day: day, disabled: disabled });
        }
        return days;
    };
    Object.defineProperty(NglDatepicker.prototype, "today", {
        get: function () {
            var today = new Date();
            return { year: today.getFullYear(), month: today.getMonth(), day: today.getDate() };
        },
        enumerable: true,
        configurable: true
    });
    NglDatepicker.decorators = [
        { type: Component, args: [{
                    selector: 'ngl-datepicker',
                    template: "\n    <div class=\"slds-datepicker__filter slds-grid\"><div class=\"slds-datepicker__filter--month slds-grid slds-grid--align-spread slds-grow\"><div class=\"slds-align-middle\"><button class=\"slds-button slds-button--icon-container\" type=\"button\" (click)=\"keyboardHandler($event, 'MoveMonth', -1)\"><svg class=\"slds-button__icon slds-button__icon--small\" nglIcon=\"left\"></svg><span class=\"slds-assistive-text\">Previous Month</span></button></div><h2 class=\"slds-align-middle\" [id]=\"uid + '_month'\" aria-live=\"assertive\" aria-atomic=\"true\">{{ monthLabel }}</h2><div class=\"slds-align-middle\"><button class=\"slds-button slds-button--icon-container\" type=\"button\" (click)=\"keyboardHandler($event, 'MoveMonth', 1)\"><svg class=\"slds-button__icon slds-button__icon--small\" nglIcon=\"right\"></svg><span class=\"slds-assistive-text\">Next Month</span></button></div></div><ngl-date-year class=\"slds-shrink-none\" [year]=\"current.year\" (yearChange)=\"moveYear($event)\"></ngl-date-year></div><table class=\"datepicker__month\" role=\"grid\" [attr.aria-labelledby]=\"uid + '_month'\"><thead><tr nglWeekdays [firstDayOfWeek]=\"firstDayOfWeek\" [dayNamesShort]=\"dayNamesShort\" [dayNamesLong]=\"dayNamesLong\"></tr></thead><tbody><tr *ngFor=\"let week of weeks; trackBy:indexTrackBy\"><td *ngFor=\"let date of week\" (click)=\"select(date)\" [class.slds-is-today]=\"isActive(date)\" [nglDay]=\"date.day\" [nglDaySelected]=\"isSelected(date)\" [nglDayDisabled]=\"date.disabled\"></td></tr><tr *ngIf=\"showToday\"><td colspan=\"7\" role=\"gridcell\"><a class=\"slds-show--inline-block slds-p-bottom--x-small\" href=\"javascript:void(0)\" (click)=\"selectToday()\">Today</a></td></tr></tbody></table>\n  ",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    host: {
                        'aria-hidden': 'false',
                        '[class.slds-datepicker]': 'true',
                        'tabindex': '0',
                    },
                    styles: [":host { display: block; }"],
                },] },
    ];
    /** @nocollapse */
    NglDatepicker.ctorParameters = function () { return []; };
    NglDatepicker.propDecorators = {
        'monthNames': [{ type: Input },],
        'dayNamesShort': [{ type: Input },],
        'dayNamesLong': [{ type: Input },],
        '_date': [{ type: Input, args: ['date',] },],
        'dateChange': [{ type: Output },],
        '_showToday': [{ type: Input, args: ['showToday',] },],
        '_firstDayOfWeek': [{ type: Input, args: ['firstDayOfWeek',] },],
        'keyboardHandler': [{ type: HostListener, args: ['keydown.Enter', ['$event', '"Enter"'],] }, { type: HostListener, args: ['keydown.ArrowUp', ['$event', '"Move"', '-7'],] }, { type: HostListener, args: ['keydown.ArrowLeft', ['$event', '"Move"', '-1'],] }, { type: HostListener, args: ['keydown.ArrowDown', ['$event', '"Move"', '7'],] }, { type: HostListener, args: ['keydown.ArrowRight', ['$event', '"Move"', '1'],] }, { type: HostListener, args: ['keydown.PageUp', ['$event', '"MoveMonth"', '-1'],] }, { type: HostListener, args: ['keydown.PageDown', ['$event', '"MoveMonth"', '1'],] }, { type: HostListener, args: ['keydown.Home', ['$event', '"MoveTo"', '1'],] }, { type: HostListener, args: ['keydown.End', ['$event', '"MoveTo"', '31'],] },],
    };
    return NglDatepicker;
}());
export { NglDatepicker };
;
//# sourceMappingURL=datepicker.js.map